<div class="h-full min-h-0 min-w-0 w-full overflow-x-hidden overflow-y-auto scrollbar-transparent">
    @if (briefActivityFeed() && briefActivityFeed()!.length > 0) {
    @for (group of activityFeedByDate(); track $index) {
    <div class="flex flex-row items-center gap-x-4 w-full py-2">
        <p class="text-sm text-secondary flex-nowrap min-w-fit">{{ group.dateLabel }}</p>
        <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
    </div>
    @for (activity of group.activities; track $index) {

    @if (!activity.applicationStatus && activity.createdByUser) {
    <brief-feed-created [activity]="activity"></brief-feed-created>
    } @else {
    @switch (activity.applicationStatus) {
    @case (ApplicationStatusEnum.Invited) {
    <brief-feed-invited [activity]="activity"
        (viewInvitesOut)="viewInvites({ tab: 2, subTab: 1 })"></brief-feed-invited>
    }
    @case (ApplicationStatusEnum.Applied) {
    <brief-feed-applied [activity]="activity"
        (viewApplicantsOut)="viewApplicants({ tab: 2, subTab: 2 })"></brief-feed-applied>
    }
    @case (ApplicationStatusEnum.Hired) {
    <brief-feed-hired [activity]="activity" (viewHiresOut)="viewHires({ tab: 2, subTab: 3 })"></brief-feed-hired>
    }
    @case (ApplicationStatusEnum.Started) {
    <brief-feed-started [activity]="activity"></brief-feed-started>
    }

    @case (ApplicationStatusEnum.Posted) {
    <brief-feed-posted [activity]="activity"
        [socialChannel]="manageBriefTabsService.focussedBrief() && manageBriefTabsService.focussedBrief()!.shoutBrief ? manageBriefTabsService.focussedBrief()!.shoutBrief!.socialPlatform : 'UGC'"></brief-feed-posted>
    }

    @case (ApplicationStatusEnum.BriefingVQAExtracted) {
    <brief-feed-vqa-extracted [activity]="activity"></brief-feed-vqa-extracted>
    }
    @case (ApplicationStatusEnum.AutoPilotOn) {
    <brief-feed-auto-pilot-on [activity]="activity"></brief-feed-auto-pilot-on>
    }
    @case (ApplicationStatusEnum.AutoPilotOff) {
    <brief-feed-auto-pilot-off [activity]="activity"></brief-feed-auto-pilot-off>
    }

    @case (ApplicationStatusEnum.ReadyToPost) {
    <!-- <brief-feed-started [activity]="activity"></brief-feed-started> -->
    <brief-feed-ready-to-post [activity]="activity"></brief-feed-ready-to-post>
    }
    }
    }
    }
    }

    } @else if (briefActivityFeed() && briefActivityFeed()!.length === 0) {
    <div class="flex flex-col items-center justify-center h-full px-6 py-8 text-center">
        <div class="flex items-center justify-center size-14 rounded-2xl bg-zinc-100 dark:bg-zinc-800/60 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-7 text-zinc-400 dark:text-zinc-500">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
            </svg>
        </div>
        <h3 class="text-sm font-semibold text-primary">No activity yet</h3>
        <p class="mt-1 text-xs text-secondary max-w-[200px]">Activity from invites, applications, hires, and posts will
            appear here.</p>
    </div>
    }
    @else {

    <div class="flex flex-col items-center justify-center h-full px-6 py-8 text-center">
        <div class="flex items-center justify-center size-14 rounded-2xl bg-zinc-100 dark:bg-zinc-800/60 mb-4">
            <svg aria-hidden="true" class="mx-auto w-12 h-12 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
        </div>
        <h3 class="text-sm font-semibold text-primary">Loading activity...</h3>
        <p class="mt-1 text-xs text-secondary max-w-[200px]">Fetching your brief timeline.</p>
    </div>
    }
</div>


@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}

<!-- @if (choosePlanService.autoPilotModalOpen()) {
<app-choose-auto-pilot [briefId]="choosePlanService.autoPilotModalOpen() || ''"
    (refreshBriefOut)="refreshBrief()"></app-choose-auto-pilot>
} -->